import { ErrorBase } from './error-base';

type PermissionDeniedData = {
  reason: string;
  actionProps?: {
    to: string;
    label: string;
  };
};

/**
 * Used for feature errors
 * MAPIG or feature-specific endpoints
 */
export class PermissionDeniedError extends ErrorBase<PermissionDeniedData> {
  constructor(data: PermissionDeniedData) {
    super(403, 'Permission Denied', data);
  }
}
